export const CATEGORY_FORM_ADD_BUTTON_TEXT = 'Ajouter du contenu';
export const CATEGORY_FORM_LINKED_CONTENT_TEXT = 'Contenus liés';
export const MAX_CONTENT_LENGTH = 40;
export const NO_CONTENT_ADDED_TITLE = 'Aucun contenu ajouté';
